// Libraries
import clsx from "clsx";

// Material UI
import { Grid, Typography, Button, Modal, Stack, IconButton, Box } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

function CloseIcon(props: { onClick: () => void }) {
	const { onClick } = props;

	return (
		<IconButton className="!absolute !right-0 !top-0 !text-gray-400" aria-label="close" onClick={onClick}>
			<CloseRoundedIcon />
		</IconButton>
	);
}

type TNotificationActionMotivatorProps = {
	notification: {
		isLoading: boolean;
		text: string;
		onAccept: () => void;
		onCancel: () => void;
	};
};

export default function NotificationActionMotivator(props: Readonly<TNotificationActionMotivatorProps>) {
	// Props
	const { notification } = props;
	const { isLoading, text, onAccept, onCancel } = notification;

	const renderContent = () => {
		return (
			<Grid item xs={12} className="!pt-0">
				<Grid container justifyContent="left" alignItems="left">
					<Stack className="!pt-3 !pb-3">
						<Typography className="!font-sans !text-[14.5px] text-default !font-normal">{text}</Typography>
					</Stack>
					<Stack className="flex justify-end" direction={"row"} spacing={3} sx={{ width: "100%" }}>
						<Button
							variant="contained"
							aria-controls="select-plan-dialog-assign-btn-menu"
							className={clsx({
								"!rounded-md h-[30px]": true,
								"!shadow-none hover:!shadow-card-gray !bg-neutral-gray": !isLoading,
								"!bg-disabled": isLoading,
							})}
							disabled={isLoading}
							onClick={() => onCancel()}
						>
							<Typography className="normal-case !font-sans !text-[14px] text-white">Cancel</Typography>
						</Button>
						<Button
							variant="contained"
							className={clsx({
								"!rounded-md h-[30px]": true,
								"!shadow-none hover:!shadow-primary-shadow-50 !bg-primary": !isLoading,
								"!bg-disabled": isLoading,
							})}
							disabled={isLoading}
							onClick={() => onAccept()}
						>
							<Typography className="normal-case !font-sans !text-[14px] text-white">Accept</Typography>
						</Button>
					</Stack>
				</Grid>
			</Grid>
		);
	};

	return (
		<Modal open={Boolean(text)} onClose={onCancel}>
			<Box className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[360px] bg-white rounded-[10px] shadow-2xl p-6">
				<CloseIcon onClick={onCancel} />
				<Stack spacing={2}>{renderContent()}</Stack>
			</Box>
		</Modal>
	);
}
